import React from 'react'
import {formatPrice} from '../../../../../Common/Formatter'
import {PAYMENT} from '../../../../../Common/Constants'
import {ContractInfoWithContractDate, CvsContractInfo, MobileCarrierInfo, MyCreditCardInfo} from '../../../../Props/ContractInputInfo'
import {ConfirmContractDetailContent} from './ConfirmContractDetailContent'
import {ContentBlock} from '../../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../../Molecules/BaseContentBlocks/ContentTitle'
import {ConfirmContent} from '../../../Molecules/BaseContentBlocks/ConfirmContent'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {PIMPrimaryButton} from '../../../Atoms/Buttons/Bases/PIMPrimaryButton'
import {PIMPageActions} from '../../../Atoms/Layouts/PIMPageActions'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyItemWarningMessageTypography} from '../../../Atoms/Typographies'

interface ContractInformationContentBlockProps {
  title: string
  contractInfoWithContractDate: ContractInfoWithContractDate
  cardInfo?: MyCreditCardInfo
  carrierInfo?: MobileCarrierInfo
  cvsInfo?: CvsContractInfo
  editButtonProps?: { buttonName: string, onClick: () => void, disabled?: boolean }
  cvsPaymentButton?: React.ReactNode
  dataTestId?: string
}

export const ContractInformationContentBlock: React.VFC<ContractInformationContentBlockProps> = (
  props,
) => {
  const {term, amount, contractDate, method} = props.contractInfoWithContractDate
  const isCvs = props.contractInfoWithContractDate.method === 'convenience_store'

  return (
    <ContentBlock data-testid={props.dataTestId}>
      <PIMStack spacing={'18px'}>
        <ContentTitle noMarginBottom={true}>{props.title}</ContentTitle>
        <PIMStack spacing={'18px'} divider={<MBContentBodyDivider/>} showEndDivider>
          <ConfirmContent
            label={'契約期間'}
            values={[
              `${PAYMENT.TERMS[term].displayLabel}${isCvs ? '' : '(自動課金継続)'}`,
              `${contractDate.contractDate} 〜 ${contractDate.contractEndDate}`,
            ]}
          />
          <ConfirmContent
            label={'お支払い金額'}
            values={
              [`${formatPrice(amount)}円(税込)`]
            }
          />
          <ConfirmContractDetailContent
            label={'お支払い方法'}
            method={method}
            cardNumber={props.cardInfo?.cardNumber}
            cardExpireDate={props.cardInfo?.expireDate}
            carrierKey={props.carrierInfo?.carrierKey}
            cvsInfo={props.cvsInfo}
            testDataId={'block-card-info'}
          />
        </PIMStack>
      </PIMStack>

      {
        (props.carrierInfo && props.editButtonProps) &&
        <Spacer mt={'25px'} dataTestId={'carrier-notice-message'}>
          <PIMStack alignItems={'center'} justifyContent={'center'} spacing={'10px'}>
            <MBContentBodyItemWarningMessageTypography>
              {'※以下の時間帯はサービスメンテナンスのため、契約変更のお手続きできませんのでご注意ください。'}
            </MBContentBodyItemWarningMessageTypography>
            <MBContentBodyItemWarningMessageTypography>
              {'月末日19:00 ～ 翌月1日23:59:59\n入会(キャリア決済へ支払い変更)日当日 〜 翌日1:00'}
            </MBContentBodyItemWarningMessageTypography>
          </PIMStack>
        </Spacer>
      }

      {props.cvsPaymentButton}

      {(props.editButtonProps) && (
        <Spacer mt={'25px'}>
          <PIMPageActions>
            <PIMPrimaryButton
              testId={'contract-edit-button'}
              disabled={props.editButtonProps?.disabled}
              onClick={(): void => {
                if (props.editButtonProps?.onClick) props.editButtonProps.onClick()
              }}
            >
              {props.editButtonProps.buttonName}
            </PIMPrimaryButton>
          </PIMPageActions>
        </Spacer>
      )}
    </ContentBlock>
  )
}
